import { __awaiter, __generator, __assign } from 'tslib';
import { useContext, useCallback } from 'react';
import { CartContext } from '../context/CartContext.esm.js';
import isEmpty from 'lodash/isEmpty';
import { useAnalyticsQueue } from '@invitae/analytics-queue';
import { isRnaAnalysisTestSelection } from '../components/OrderCard/OrderCard.utils.esm.js';
import { AnalyticsEventName } from '../constants/analytics.esm.js';

var useMakeActions = function (actionParameters) {
    var _a = useContext(CartContext), addPartnerships = _a.addPartnerships, addToCart = _a.addToCart, cart = _a.cart, clearCart = _a.clearCart, clearCartErrors = _a.clearCartErrors, gotoCartPage = _a.gotoCartPage, partnershipToAdd = _a.partnershipToAdd, removeFromCart = _a.removeFromCart, removeReflexTests = _a.removeReflexTests, setPartnershipToAdd = _a.setPartnershipToAdd;
    var concepts = actionParameters.concepts;
    var logEvent = useAnalyticsQueue().logEvent;
    var clearAndAddConcepts = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!concepts || isEmpty(concepts)) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, clearCart()
                        // Adding concepts and partnerships need to be done sequentially for validation
                    ];
                case 1:
                    _a.sent();
                    // Adding concepts and partnerships need to be done sequentially for validation
                    return [4 /*yield*/, addToCart(concepts)];
                case 2:
                    // Adding concepts and partnerships need to be done sequentially for validation
                    _a.sent();
                    if (!partnershipToAdd) return [3 /*break*/, 4];
                    return [4 /*yield*/, addPartnerships(partnershipToAdd)];
                case 3:
                    _a.sent();
                    setPartnershipToAdd('');
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [addPartnerships, addToCart, clearCart, concepts, partnershipToAdd, setPartnershipToAdd]);
    var clearRnaAnalysisAndAddConcepts = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, richReflexTests, _g, rna, _h, rereqSetCode, _j, testSelections, isParentRnaAnalysisSelected, isReflexRnaAnalysisSelected, getRnaGeneCodes, parentRnaGeneCodes, reflexRnaGeneCodes;
        var _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!concepts || isEmpty(concepts)) {
                        return [2 /*return*/];
                    }
                    _a = ((_k = cart === null || cart === void 0 ? void 0 : cart.orderGroups) === null || _k === void 0 ? void 0 : _k[0]) || {}, _b = _a.meta, _c = _b === void 0 ? {} : _b, _d = _c.reflex, _e = _d === void 0 ? {} : _d, _f = _e.richReflexTests, richReflexTests = _f === void 0 ? [] : _f, _g = _c.rna, rna = _g === void 0 ? {} : _g, _h = _a.rereqSetCode, rereqSetCode = _h === void 0 ? '' : _h, _j = _a.testSelections, testSelections = _j === void 0 ? [] : _j;
                    isParentRnaAnalysisSelected = rna.isParentRnaAnalysisSelected, isReflexRnaAnalysisSelected = rna.isReflexRnaAnalysisSelected;
                    getRnaGeneCodes = function (tests) { var _a, _b, _c; return ((_c = (_b = (_a = tests === null || tests === void 0 ? void 0 : tests.filter(function (test) { return isRnaAnalysisTestSelection(test.name); })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.genes) === null || _c === void 0 ? void 0 : _c.map(function (gene) { return gene.code; })) || []; };
                    parentRnaGeneCodes = getRnaGeneCodes(testSelections);
                    reflexRnaGeneCodes = getRnaGeneCodes(richReflexTests);
                    if (!(isParentRnaAnalysisSelected && parentRnaGeneCodes.length)) return [3 /*break*/, 2];
                    return [4 /*yield*/, removeFromCart(parentRnaGeneCodes, undefined, undefined, { expandWithRna: false })];
                case 1:
                    _l.sent();
                    logEvent({
                        eventName: AnalyticsEventName.DeselectParentRnaAnalysisModal,
                        eventProperties: __assign({}, rna),
                    });
                    _l.label = 2;
                case 2:
                    if (!(isReflexRnaAnalysisSelected && reflexRnaGeneCodes.length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, removeReflexTests(rereqSetCode, reflexRnaGeneCodes, { expandWithRna: false })];
                case 3:
                    _l.sent();
                    logEvent({
                        eventName: AnalyticsEventName.DeselectReflexRnaAnalysisModal,
                        eventProperties: __assign({}, rna),
                    });
                    _l.label = 4;
                case 4: return [4 /*yield*/, addToCart(concepts)];
                case 5:
                    _l.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [addToCart, cart === null || cart === void 0 ? void 0 : cart.orderGroups, concepts, logEvent, removeFromCart, removeReflexTests]);
    var keepOrder = useCallback(function () {
        clearCartErrors();
        if (partnershipToAdd)
            setPartnershipToAdd('');
    }, [clearCartErrors, partnershipToAdd, setPartnershipToAdd]);
    return {
        clearAndAddConcepts: clearAndAddConcepts,
        clearCart: clearCart,
        clearRnaAnalysisAndAddConcepts: clearRnaAnalysisAndAddConcepts,
        gotoCartPage: gotoCartPage,
        keepOrder: keepOrder,
    };
};

export { useMakeActions };
//# sourceMappingURL=actions.esm.js.map
